import { useState, useEffect } from "react";
import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function Gaming() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const splitTextToSpans = (text, className = "") =>
        [...text].map((char, index) => (
            <span className={`char ${className}`} key={`${char}-${index}`}>
                {char === " " ? "\u00A0" : char}
            </span>
        ));

    // light dark change image

    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const currentTheme =
            document.documentElement.getAttribute("data-theme") || "light";
        setTheme(currentTheme);

        const observer = new MutationObserver(() => {
            const newTheme =
                document.documentElement.getAttribute("data-theme") || "light";
            setTheme(newTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Helmet>
                <title>Blockchain Game Development Services | Web3 Gaming | Blockcryp</title>
                <meta
                    name="description"
                    content="Create immersive blockchain games with Blockcryp. We build play-to-earn (P2E) games, NFT integrations, metaverse experiences, and Web3 gaming platforms."
                />
                <meta
                    name="keywords"
                    content="blockchain game development, Web3 gaming development, play-to-earn game development, NFT gaming solutions, crypto gaming platform, metaverse game development, decentralized gaming apps, GameFi development services, NFT game developers, custom blockchain games"
                />
            </Helmet>
            {/* ---------- hero section start ---------- */}
            <section className="space80">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h1
                                className="heading_h1 fw-bold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                Unity 3D Game Development
                            </motion.h1>
                            <motion.p
                                className="pera_txt"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                What if your game could reach millions across platforms with just one engine? Unity makes that possible and more. With <b> Unity 3D game development, </b> businesses gain faster turnaround, smoother performance, and unmatched visual fidelity. It’s the gold standard for turning bold ideas into polished, high-impact experiences. To stay ahead in the gaming industry, working with top-tier Unity experts is your ultimate advantage.
                            </motion.p>

                            <button class="button theme_btn mt-lg-4 mt-0" type="submit">
                                Build with Unity
                            </button>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/game/gamehero.gif"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/game/gamehero.gif" alt="" className="w-100 d-md-block d-none" /> */}
                                {/* <img src="assets/images/game/gamehero2.gif" alt="" className="w-100 d-md-none d-block" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Game Development Services section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-10 mb-4 mb-lg-5">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center"
                            >
                                <>
                                    {splitTextToSpans(" Core ")}
                                    {splitTextToSpans("Game Development Services", "text-primary")}
                                </>
                            </ScrollFloat>
                            {/* <h2 className="heading_h3 fw-semibold text-center">Unity <span className="text-primary"> Game Development Services</span></h2> */}
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Explore our wide array of game development services, ideal for startups, SMBs, and globally renowned firms. Elevating your gaming endeavors, we offer a tailored approach that aligns seamlessly with the dynamic requirements of your gaming project.</motion.p>
                        </div>
                    </div>
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h5
                                className="heading_h5 fw-semibold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Blockchain-Based Game Development</motion.h5>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">P2E game development :</h5>
                                <p className="text_14">Unlock tangible rewards for in-game achievements with our play-to-earn solutions. Enjoy dynamic in-game economies, secure transactions, and empowered ownership.</p>
                            </motion.div>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">NFT Game Development :</h5>
                                <p className="text_14">Transform in-game assets into valuable digital artifacts with our NFT game development services. Build robust ecosystems with authenticity and rarity.</p>
                            </motion.div>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">Web3 Game Development :</h5>
                                <p className="text_14">Merge gaming with decentralized technologies. Our Web3 games emphasize digital ownership, provable scarcity, interoperability, and cutting-edge gamification strategies.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-5 order-lg-2 order-1 ps-lg-5 ms-lg-5">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/game/services1.gif"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/game/services1.gif" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- AR/VR Game Development Services section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-5 pe-lg-5 me-lg-5">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/game/services2.gif"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/game/services2.gif" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h5
                                className="heading_h5 fw-semibold"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Platform-Specific Game Development</motion.h5>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">Mobile Game Development :</h5>
                                <p className="text_14">Create captivating games optimized for various devices. From smooth touch controls to stunning graphics, our mobile game solutions deliver an exceptional on-the-go gaming experience. Harness the power of mobile-first strategies for maximum player reach.</p>
                            </motion.div>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">Desktop Game Development :</h5>
                                <p className="text_14">Redefine desktop gaming with resource-intensive graphics, complex simulations, and immersive adventures. We push the boundaries of what’s possible on desktop platforms, enabling AAA-quality experiences.</p>
                            </motion.div>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">HTML5 Game Development :</h5>
                                <p className="text_14">Step into cross-platform gaming with our HTML5 solutions. Enjoy consistent and engaging experiences on any device through responsive designs, lightweight frameworks, and dynamic gameplay optimized for modern web browsers.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Cross-Platform Game Development section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h5
                                className="heading_h5 fw-semibold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Engine-Specific Game Development</motion.h5>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">Unity Game Development :</h5>
                                <p className="text_14">Leverage the power of Unity 3D to build immersive experiences that transcend traditional gaming. From stunning visuals to seamless gameplay, Unity games crafted by us captivate players worldwide with real-time rendering and VR/AR compatibility.</p>
                            </motion.div>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">Unreal Game Development :</h5>
                                <p className="text_14">Create visually striking games with the Unreal Engine. Beyond world-class graphics and animations, our Unreal game development focuses on compelling narratives, dynamic gameplay mechanics, and cinematic-quality experiences.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-5 order-lg-2 order-1 ps-lg-5 ms-lg-5">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/game/services3.gif"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/game/services3.gif" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Metaverse Game Development section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/game/services4.gif"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/game/services4.gif" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h5
                                className="heading_h5 fw-semibold"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Immersive Technologies</motion.h5>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">Metaverse Game Development :</h5>
                                <p className="text_14">Craft interconnected gaming universes where actions in one game influence another. Our expertise ensures an immersive, cohesive metaverse experience that redefines player engagement in virtual worlds.</p>
                            </motion.div>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">AR/VR/MR Game Development :</h5>
                                <p className="text_14">Dive into the extraordinary with Blockcryp's AR/VR/MR game development, where our subject matter experts don't just craft games; we weave alternate dimensions where AR elements dance in the real world, VR immerses players in fantastical realms, and MR orchestrates a symphony of digital and physical harmony.</p>
                            </motion.div>
                            <motion.div
                                className="how_card mt-3"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="fw-semibold">AI Game Development :</h5>
                                <p className="text_14">Introduce intelligence into your games. Our AI-powered solutions create responsive, dynamic, and intuitive gaming experiences that resonate with players’ emotions and intellect. Leverage AI-driven personalization, adaptive difficulty levels, and intelligent NPC behavior.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Process section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row justify-content-center mb-4 mb-lg-5">
                        <div className="col-lg-10 col-12">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center"
                            >
                                <>
                                    {splitTextToSpans(" Our Game Design and ")} <br className="d-md-block d-none" />
                                    {splitTextToSpans("Development Process", "text-primary")}
                                </>
                            </ScrollFloat>
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >At Blockcryp, we're not just crafting games; we're sculpting unique experiences through an agile process that sets us apart.</motion.p>
                        </div>
                    </div>
                    <div className="row justify-content-center g-4">
                        <div className="col-lg-4">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="text_20 fw-semibold">1. Game Design and Feature Planning</h5>
                                <p className="mb-0">Our qualified game developers will methodically finalize features that resonate with players' expectations, setting the foundation with meticulous planning.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="text_20 fw-semibold">2. Art and Asset Creation</h5>
                                <p className="mb-0">Our game design and development experts create immersive worlds, characters, and assets, aligning every element with the overarching vision.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="text_20 fw-semibold">3. Conceptualization and Market Analysis</h5>
                                <p className="mb-0">Our game development company engages in a rigorous conceptualization process, undergoes a strategic transformation, and meticulously analyzes the gaming landscape.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="text_20 fw-semibold">4. Prototype Development and Testing</h5>
                                <p className="mb-0">Through systematic prototype development, each iteration is rigorously tested for adaptability and engagement, with a focus on refining, perfecting, and exceeding expectations.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="text_20 fw-semibold">5. Launch and Community Building</h5>
                                <p className="mb-0">The launch day isn't just a culmination; it's the commencement of a strategic community-building process while we cultivate player engagement systematically.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Gaming Solutions section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/game/solution.gif"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/game/solution.gif" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h3
                                className="heading_h3 fw-semibold"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                Engineering Scalable & Story-Driven Gaming Solutions</motion.h3>
                            <motion.p
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >At Blockcryp, we engineer intelligent gaming architectures that scale seamlessly across platforms and player bases. By fusing AI-driven decision systems, modular backends, and emotionally rich storytelling, we create experiences that adapt, evolve, and captivate. From indie concepts to enterprise-grade titles, our solutions are built for impact, performance, and longevity.
                            </motion.p>
                            <button class="button theme_btn mt-lg-4 mt-0" type="submit">
                                Discuss Your Project
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- 3D Development section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-12 mb-3">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center"
                            >
                                Why Choose Us for Your Unity <br className="d-md-block d-none" /> 3D Development?
                            </ScrollFloat>
                            {/* <h2 className="heading_h3 fw-semibold text-center">Advanced Crypto Exchange Development Models to Scale Your Crypto Business</h2> */}
                        </div>
                        <div className="col-lg-4 col-md-6 ">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Diverse Game Development</h5>
                                <p>We bring ideas to life across genres like action, adventure, simulation, and <span className="text-primart fw-semibold"> blockchain game development. </span> Our creative depth ensures your game stands out with unique mechanics and up-to-date features.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6 ">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Collaborative Team</h5>
                                <p>Our team works closely with you from concept to completion. With transparent communication and shared goals, we ensure every detail reflects your vision, delivering a seamless and successful development experience.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6 ">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Cross-Platform Development</h5>
                                <p>We specialize in building high-performance games across devices, with strong expertise in <span className="text-primary fw-semibold"> casual game development. </span> Reach wider audiences with smooth gameplay experiences on mobile, desktop, console, and web platforms.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6 ">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Flexibility and Scalability</h5>
                                <p>Whether you’re launching a small game or scaling to millions of users, our flexible architecture and modular development process adapt to your project’s evolving needs today and into the future.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6 ">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Ongoing Support Post-Launch</h5>
                                <p>We don’t stop at deployment. From bug fixes to updates and marketing integration, we support every stage of your journey, including  <span className="text-primary fw-semibold">cryptocurrency game development, </span> to ensure lasting performance and growth.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6 ">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Certified Unity 3D Developers</h5>
                                <p>Our Unity-certified experts deliver excellence. With deep technical knowledge and creative skill, we craft polished, efficient, and visually stunning 3D games that exceed industry standards and player expectations.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- faq section start ---------- */}
            <section className="space80">
                <div className="container">
                    <h2 className="heading_h3 fw-bold mb-4">Frequently Asked Questions</h2>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion">
                                <div className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(0)}>
                                        <span className="text_20 pe-4">
                                            1.  What are the benefits of game development services?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Game development services extend far beyond the creation of mere entertainment; they craft immersive experiences that resonate with audiences on a profound level. Beyond technical proficiency, these services harness the strategic fusion of storytelling, graphics, and mechanics, elevating brand visibility and user retention. Collaborating with seasoned professionals in the industry unlocks the potential for innovative gameplay, ensuring the game becomes a standout player in a fiercely competitive market.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(1)}>
                                        <span className="text_20 pe-4">
                                            2. How long does it take to create a game?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            While simple mobile games may manifest in the span of a few weeks, complex high-end projects for consoles or PCs unfold over months. Different set of features and development stages—conceptualization, design, development, testing, and optimization—decide the overall time for developing a game.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(2)}>
                                        <span className="text_20 pe-4">
                                            3.  How much does it cost to develop a game app?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Cost is based on factors such as game complexity, targeted platforms, and integrated features. Simple mobile games may cast a spell with a few thousand dollars, while grander endeavors for high-end consoles or PC platforms conjure budgets ranging from hundreds of thousands to the ethereal realm of millions.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(3)}>
                                        <span className="text_20 pe-4">
                                            4.  How to create a P2E game in Unity?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Choose a blockchain, like Ethereum or Binance Smart Chain, and set up smart contracts for in-game stuff and transactions. Make in-game items special by turning them into NFTs, so players truly own them. Identify some blockchain wallets for safekeeping and unity in the game. Throw in some DeFi tricks like staking and yield farming to make it interesting. Shape Unity to sync with your chosen blockchain, making the game world come alive. Test everything, launch strategically, and connect with players.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 " onClick={() => toggleItem(4)}>
                                        <span className="text_20 pe-4">
                                            5. What are some things to consider when choosing a game development company?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            There are numerous parameters to consider while you look for a game development company. The company’s mastery in project management, experience in the gaming industry, portfolio, communication, and adherence to timelines become crucial elixirs for harmonious collaboration. Testimonials and reviews unfold like ancient scrolls, offering glimpses into the company’s reputation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
